import React, { useEffect, useState, } from "react";
import { Box, Autocomplete, IconButton, useTheme, TextField, CircularProgress, InputLabel, MenuItem, Select, Avatar, Typography } from "@mui/material";
// import { AddCircleRounded } from "@mui/icons-material";
// import { useLocation } from "react-router-dom";

import { ReactComponent as Menu } from "../../assets/images/menu.svg";
import Modal from "../../components/Modal";
import styles from "./style";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SettingPopUp from "../Popup";
import NotificationBell from "../NotificationBell";


const Topbar = ({ handleLogout, mobileViewOpen, setMobileViewOpen, handleDownload, loading, employeeData, handleEmployee, open, setOpen, companyName, companyLogo }) => {
  const theme = useTheme();
  const [selectedType, setSelectedType] = useState("");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [email, setEmail] = useState();
  // const [from, setFrom] = useState("");

  const [employeeId, setEmployeeId] = useState("");
  const [data, setData] = useState([]);
  // const permission = localStorage.getItem("permission");

  const applyRequest = () => {
    handleDownload(selectedType, fromDate, toDate, email, employeeId, data);
    
  }

  useEffect(()=>{
    if(!open){
      setSelectedType("");
      setFromDate("");
      setToDate("");
      setEmail("");
      setEmployeeId("");
      setData([]);
    }
  },[open])
  const handleChecked = (checked, val) => {
    if (checked) {

      setData([...data, val])
    }
  }
  const navigate = useNavigate();
  // const role =localStorage.getItem("role");
  // const location = useLocation();


  const handleGoBack = () => {
    navigate(-1); // This will navigate to the previous page in history
  };
  // const handleNavigateBack = () => {
    // setFrom("")
    // navigate("/dashboard/accountSettings", { state: { from: "New" } })

  // }


  return (
    <>
      <Box sx={styles.mainGrid}>
        <IconButton onClick={() => setMobileViewOpen(!mobileViewOpen)} sx={{ display: { sm: "none" } }}>
          <Menu />
        </IconButton>
        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
          <Button variant="contained" color="primary" onClick={handleGoBack} sx={styles.bckBtn}>
            <ArrowBackIcon />
          </Button>
        </Box>
        <Box display="flex" flexDirection="row" alignItems="center" gap={2} >
          {/* {location.pathname === "/dashboard/accountSettings" && role === "Admin" &&  (from == "" || permission?.account?.isEdit) && <Button variant="contained" type="submit" color="success" sx={styles.addButtons} onClick={() => handleNavigateBack()}>
            <AddCircleRounded sx={{ marginRight: "5px" }} />
            Add New Company
          </Button>
          } */}
          {companyName && (
            <Box sx={styles.companyInfo}>
              <Avatar src={companyLogo} variant="rounded" sx={styles.companyLogo}>
                {companyName?.charAt(0)}
              </Avatar>
              <Typography sx={styles.companyName} title={companyName}>
                {companyName}
              </Typography>
            </Box>
          )}
          <Box display="flex">
            <NotificationBell />
            <SettingPopUp handleLogout={handleLogout} />
          </Box>
        </Box>
      </Box>

      <Modal open={open} setOpen={setOpen} disabled={!email || !fromDate || !toDate || !selectedType} btnText={"Export"} title={"Export Auditor Data"} handleCheck={applyRequest} loading={loading}>
        <Box sx={styles.containerInput}>
          <Box sx={{ width: "57%" }}>

            <InputLabel sx={styles.label}>Type</InputLabel>
            <Select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              name="type"
              sx={styles.dropDownMenu}
            >
              <MenuItem sx={styles.dropDownMenu} value="All">All</MenuItem>
              <MenuItem sx={styles.dropDownMenu} value="Single">Single</MenuItem>

            </Select>

          </Box>


          <Box sx={{ ml: 1 }}>
            <InputLabel sx={styles.label}>Email</InputLabel>
            <TextField
              value={email}
              // label={from === "checkIn"?"Check In Time":"check Out Time"}
              name="email"
              // disabled={!employeeId}
              placeholder="Enter Email Address"
              // defaultValue={checkInTime}
              onChange={(e) => setEmail(e.target.value)}
              // error={error}
              // helperText={error}
              sx={styles.modalInput}
            />
          </Box>
        </Box>
        {selectedType === "Single" && (


          <Box>
            <Autocomplete
              id="autocomplete"
              options={employeeData || []}
              getOptionLabel={(option) => option?.personalInfo?.email}
              onInputChange={(event, newInputValue) => {
                handleEmployee(newInputValue);
              }}

              onChange={(event, newValue) => {
                setEmployeeId(newValue?._id)
              }}

              renderInput={(params) => (
                <><InputLabel sx={styles.label}>{"Employee Email"}</InputLabel><TextField
                  {...params}
                  sx={{ ...styles.modalInput, ...styles.inputSpace }}

                  // label="Search Employee"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }} /></>
              )}
            />
          </Box>
        )}
        <Box sx={styles.containerInput}>
          <Box>
            <InputLabel sx={styles.label}>From</InputLabel>
            <TextField
              value={fromDate}
              type="date"
              name="from"
              // disabled={!employeeId}
              // placeholder="Enter Email Address"
              // defaultValue={checkInTime}
              onChange={(e) => setFromDate(e.target.value)}
              // error={error}
              // helperText={error}
              sx={styles.modalInput}
            />

          </Box>


          <Box sx={{ ml: 1 }}>
            <InputLabel sx={styles.label}>To</InputLabel>
            <TextField
              value={toDate}
              type="date"
              name="to"
              // disabled={!employeeId}
              // placeholder="Enter Email Address"
              // defaultValue={checkInTime}
              onChange={(e) => setToDate(e.target.value)}
              // error={error}
              // helperText={error}
              sx={styles.modalInput}
            />
          </Box>
        </Box>
        <FormControlLabel sx={styles.formControlLabel} control={<Checkbox onChange={(e) => handleChecked(e.target.checked, "Attendance")} />} label="Attendence" />
        <FormControlLabel sx={styles.formControlLabel} control={<Checkbox onChange={(e) => handleChecked(e.target.checked, "Timesheet")} />} label="Timesheet" />

        <FormControlLabel sx={styles.formControlLabel} control={<Checkbox onChange={(e) => handleChecked(e.target.checked, "Salary")} />} label="Salary" />


      </Modal>
    </>
  );
};

export default Topbar;
